// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import NavigationBar from "../../Components/NavigationBar";
// import axios from "axios";

// export default function SendEmailBursar() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
//   const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL;

//   const { selectedApplications } = location.state || {};
//   const [recipientName, setRecipientName] = useState("");
//   const [recipientEmail, setRecipientEmail] = useState("");
  
//   const [emailSubject, setEmailSubject] = useState(
//     "URC Approval for APC Reimbursement – Payment Details "
//   );
//   const [emailBody, setEmailBody] = useState("");

//   // Generate a single link containing all application IDs
//   const generateCombinedLink = () => {
//     if (!selectedApplications || !Array.isArray(selectedApplications))
//       return "";

//     const applicationIds = selectedApplications
//       .map((app) => app.Application_Id)
//       .join(",");
//     return `${FRONTEND_BASE_URL}/bursarapprove?applicationId=${applicationIds}`;
//   };

//   // Set default email body when component loads
//   useEffect(() => {
//     if (selectedApplications && selectedApplications.length > 0) {
//       const defaultBody = `Dear Bursar,\n\nThe University Research Council (URC) is pleased to confirm that the following application for Article Processing Charge (APC) reimbursement has been reviewed and meets the eligibility criteria for funding. You are now authorized to proceed with the payment as outlined below.

// Payment Details
// Name of Applicant: 
// Title of Manuscript:
// Amount to be Paid:

// You can view all submission details, including payment details, by logging into the URC Grant and Award Management System. 
// View all applications: ${generateCombinedLink()}.I would be grateful if you could process the payment at your earliest convenience.\n\n
// This is System Generated Email.Please Don't Reply.\n
// Best Regards,\nURC Director`;
//       setEmailBody(defaultBody);
//     }
//   }, [selectedApplications]);

//   const handleSendEmail = async () => {
//     const combinedLink = generateCombinedLink();
//     const updatedEmailBody = `Dear Bursar,\n\nThe University Research Council (URC) is pleased to confirm that the following application for Article Processing Charge (APC) reimbursement has been reviewed and meets the eligibility criteria for funding. You are now authorized to proceed with the payment as outlined below.

// Payment Details
// Name of Applicant: 
// Title of Manuscript:
// Amount to be Paid:

// You can view all submission details, including payment details, by logging into the URC Grant and Award Management System. 
// View all applications: ${generateCombinedLink()}.I would be grateful if you could process the payment at your earliest convenience.\n\n
// This is System Generated Email.Please Don't Reply.
// Best Regards,\nURC Director`;

//     setEmailBody(updatedEmailBody);

//     try {
//       // Save email details for each selected application
//       await Promise.all(
//         selectedApplications.map((app) =>
//           axios.post(`${API_BASE_URL}/saveBursarEmailDetails`, {
//             App_Id: app.Application_Id,
//             Bursar_Name: recipientName,
//             Bursar_Email: recipientEmail,
//             Sent: 1,
//           })
//         )
//       );

//       alert("Emails sent successfully!");
//       navigate("/sendcompletedapplications");
//     } catch (error) {
//       console.error("Failed to save email records:", error);
//       alert("Failed to send emails. Please try again.");
//     }
//   };

//   return (
//     <div>
//       <NavigationBar />
//       <div className="container mt-4">
//         <h2 className="page-name">Send Email to Bursar</h2>
//         <Form>
//           <Form.Group className="mb-3">
//             <Form.Label>Recipient Name</Form.Label>
//             <Form.Control
//               type="text"
//               value={recipientName}
//               onChange={(e) => setRecipientName(e.target.value)}
//               placeholder="Enter recipient's name"
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Recipient Email</Form.Label>
//             <Form.Control
//               type="email"
//               value={recipientEmail}
//               onChange={(e) => setRecipientEmail(e.target.value)}
//               placeholder="Enter recipient's email"
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Email Subject</Form.Label>
//             <Form.Control
//               type="text"
//               value={emailSubject}
//               onChange={(e) => setEmailSubject(e.target.value)}
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Email Body</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={10}
//               value={emailBody}
//               onChange={(e) => setEmailBody(e.target.value)}
//             />
//           </Form.Group>

//           <div className="mb-3">
//             <p className="emaillink" style={{ color: "black" }}>
//               <strong>Email Link (For Senders Reference):</strong>
//             </p>
//             <a
//               href={generateCombinedLink()}
//               target="_blank"
//               rel="noopener noreferrer"
//               style={{ color: "black" }}
//             >
//               {generateCombinedLink()}
//             </a>
//           </div>

//           <Button
//             variant="primary"
//             className="Send_Button"
//             onClick={handleSendEmail}
//           >
//             Send
//           </Button>
//         </Form>
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import NavigationBar from "../../Components/NavigationBar";
import axios from "axios";

export default function SendEmailBursar() {
  const location = useLocation();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
  const FRONTEND_BASE_URL = process.env.REACT_APP_FRONTEND_BASE_URL || 'http://localhost:3000';

  const { selectedApplications } = location.state || {};
  const [recipientName, setRecipientName] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [emailSubject, setEmailSubject] = useState(
    "URC Approval for APC Reimbursement – Payment Details"
  );
  const [emailBody, setEmailBody] = useState("");

  // Generate a single link containing all application IDs
  const generateCombinedLink = () => {
    if (!selectedApplications || !Array.isArray(selectedApplications)) return "";
    const applicationIds = selectedApplications
      .map((app) => app.Application_Id)
      
      .join(",");
    return `${FRONTEND_BASE_URL}/bursarapprove?applicationId=${applicationIds}`;
  };

  // Set default email body when component loads
  useEffect(() => {
    if (selectedApplications && selectedApplications.length > 0) {
      const defaultBody = `Dear Bursar,\n\nThe University Research Council (URC) is pleased to confirm that the following application(s) for Article Processing Charge (APC) reimbursement have been reviewed and meet the eligibility criteria for funding. You are now authorized to proceed with the payment(s) as outlined below.\n\nPayment Details:\n${selectedApplications
        .map(
          (app, index) =>
            `${index + 1}. Application ID: ${app.Application_Id}\n   Name of Applicant: ${app.Name || 'N/A'}\n   Title of Manuscript: ${app.Manuscript_Title || 'N/A'}\n   Amount to be Paid: ${app.Amount || 'N/A'}\n`
        )
        .join('\n')}You can view all submission details, including payment details, by logging into the URC Grant and Award Management System.\nView all applications: ${generateCombinedLink()}\n\nI would be grateful if you could process the payment(s) at your earliest convenience.\n\nThis is a System Generated Email. Please Do Not Reply.\n\nBest Regards,\nURC Director`;
      setEmailBody(defaultBody);
    }
  }, [selectedApplications]);

  const handleSendEmail = async () => {
    if (!recipientName || !recipientEmail) {
      alert("Please fill in recipient name and email.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipientEmail)) {
      alert("Please enter a valid email address.");
      return;
    }
    if (!selectedApplications || selectedApplications.length === 0) {
      alert("No applications selected.");
      return;
    }

    const combinedLink = generateCombinedLink();
    const updatedEmailBody = `Dear Bursar,\n\nThe University Research Council (URC) is pleased to confirm that the following application(s) for Article Processing Charge (APC) reimbursement have been reviewed and meet the eligibility criteria for funding. You are now authorized to proceed with the payment(s) as outlined below.\n\nPayment Details:\n${selectedApplications
      .map(
        (app, index) =>
          `${index + 1}. Application ID: ${app.Application_Id}\n   Name of Applicant: ${app.Name || 'N/A'}\n   Title of Manuscript: ${app.Manuscript_Title || 'N/A'}\n   Amount to be Paid: ${app.Amount || 'N/A'}\n`
      )
      .join('\n')}You can view all submission details, including payment details, by logging into the URC Grant and Award Management System.\nView all applications: ${combinedLink}\n\nI would be grateful if you could process the payment(s) at your earliest convenience.\n\nThis is a System Generated Email. Please Do Not Reply.\n\nBest Regards,\nURC Director`;

    try {
      // Save email details for each selected application
      await Promise.all(
        selectedApplications.map((app) =>
          axios.post(`${API_BASE_URL}/saveBursarEmailDetails`, {
            App_Id: app.Application_Id,
            Bursar_Name: recipientName,
            Bursar_Email: recipientEmail,
            Sent: 1,
          })
        )
      );

      // Send email via nodemailer
      const response = await axios.post(`${API_BASE_URL}/sendEmail`, {
        to: recipientEmail,
        subject: emailSubject,
        text: updatedEmailBody,
        html: `<p>${updatedEmailBody.replace(/\n/g, '<br>')}</p>`,
      });

      alert(response.data.message); // e.g., "Email sent successfully"
      navigate("/sendcompletedapplications");
    } catch (error) {
      console.error("Failed to send email or save records:", error);
      alert("Failed to send email. Please try again.");
    }
  };

  return (
    <div>
      <NavigationBar />
      <div className="container mt-4">
        <h2 className="page-name">Send Email to Bursar</h2>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Recipient Name</Form.Label>
            <Form.Control
              type="text"
              value={recipientName}
              onChange={(e) => setRecipientName(e.target.value)}
              placeholder="Enter recipient's name"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Recipient Email</Form.Label>
            <Form.Control
              type="email"
              value={recipientEmail}
              onChange={(e) => setRecipientEmail(e.target.value)}
              placeholder="Enter recipient's email"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email Subject</Form.Label>
            <Form.Control
              type="text"
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email Body</Form.Label>
            <Form.Control
              as="textarea"
              rows={10}
              value={emailBody}
              onChange={(e) => setEmailBody(e.target.value)}
            />
          </Form.Group>

          <div className="mb-3">
            <p className="emaillink" style={{ color: "black" }}>
              <strong>Email Link (For Sender's Reference):</strong>
            </p>
            <a
              href={generateCombinedLink()}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "black" }}
            >
              {generateCombinedLink()}
            </a>
          </div>

          <Button
            variant="primary"
            className="Send_Button"
            onClick={handleSendEmail}
            disabled={!selectedApplications || selectedApplications.length === 0}
          >
            Send
          </Button>
        </Form>
      </div>
    </div>
  );
}